export const BROWSERS = [
  "Chrome",
  "Edge",
  "Firefox",
  "Internet Explorer",
  "Safari",
  "Opera",
  "Yandex",
  "Chromium",
  "Vivaldi",
  "Baidu",
  "Brave",
];
